/**
 * Sub-nav for the three uploads pages.
 *
 * SegmentedControl over Portal / Templates / History. Active segment is
 * derived from the URL so the same component works on all three pages
 * (no parent prop needed). Routing happens via `useNavigate`.
 */

import { SegmentedControl } from "@mantine/core";
import { useLocation, useNavigate } from "react-router-dom";

const ROUTES = [
  { value: "/uploads", label: "Portal" },
  { value: "/uploads/templates", label: "Templates" },
  { value: "/uploads/history", label: "History" },
] as const;

export function UploadsTabs() {
  const location = useLocation();
  const navigate = useNavigate();

  // Match the longest prefix — /uploads/templates and /uploads/history
  // must win over /uploads (which is a prefix of both).
  const active = (() => {
    const sorted = [...ROUTES].sort((a, b) => b.value.length - a.value.length);
    return sorted.find((r) => location.pathname === r.value)?.value ?? "/uploads";
  })();

  return (
    <SegmentedControl
      value={active}
      onChange={(v) => navigate(v)}
      data={ROUTES.map((r) => ({ value: r.value, label: r.label }))}
      size="sm"
    />
  );
}
